export default class PhotoAnalysisResultSection {
  constructor({ name, propertyName, color, questions = [] }) {
    this.name = name;
    this.propertyName = propertyName;
    this.color = color;
    this.questions = questions;
  }
}
